import React from 'react'
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableContainer from '@mui/material/TableContainer';
import { Button } from '@mui/material';


const columns = [
    { id: 'room_id', label: 'Serial Number' },
    { id: 'actions', label: 'Actions'}
];

const RemoteDeviceTable = ({list,handleRedirect}) => {

    return (
        <Box>
            <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                <TableContainer>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                            <TableCell
                                key={column.id}
                                align={column.align}
                                style={{ minWidth: column.minWidth }}
                            >
                                {column.label}
                            </TableCell>
                            ))}
                        </TableRow>
                        </TableHead>
                        <TableBody>
                        { list?.length > 0 ?  list?.map((row,i) => {
                            return (
                                <TableRow hover role="checkbox" tabIndex={-1} key={i}>
                                {columns.map((column) => {
                                    const value = row[column.id];
                                    return (
                                    <TableCell key={column.id} align={column.align}>
                                        {column.format && typeof value === 'number'
                                        ? column.format(value)
                                        : column.id === 'actions' ?
                                            <Button
                                                sx={{mr:1}}
                                                variant="contained"
                                                size="small"
                                                color="primary"
                                                onClick={(e)=>handleRedirect(e)}
                                                value={row['room_id']}
                                                data-id ={row['id']}
                                            >Connect</Button>
                                        : value }
                                    </TableCell>
                                );
                                })}
                            </TableRow>
                            );
                        }): <TableRow><TableCell colSpan={3}>No Data Available. </TableCell></TableRow>}
                        </TableBody>
                    </Table>
                </TableContainer>
                {/* { list?.total > 0 ?  
                <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={list?.total}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
                : <></> } */}
            </Paper>
        </Box>
    )
}

export default RemoteDeviceTable